import { Card, CommandButton } from "components"

type CommandButtonsProps = {
  showDeleteButton?: boolean
  onDelete?: () => void
  onSave?: () => void
}

export const CommandButtons = ({ showDeleteButton, onDelete, onSave }: CommandButtonsProps) => {
  return (
    <Card>
      <Card.Body className="flex flex-col gap-5">
        <section className="flex flex-wrap justify-between gap-3">
          <section className="flex flex-wrap gap-3">
            <CommandButton actiontype="help" />
            <CommandButton actiontype="print" />
            <CommandButton actiontype="email" />
            <CommandButton actiontype="journal" />
            <CommandButton actiontype="attachment" />
          </section>

          <section className="flex flex-wrap gap-3">
            {showDeleteButton && <CommandButton actiontype="delete" onClick={onDelete} />}
            <CommandButton
              actiontype="save"
              type="button"
              color="primary"
              permission="ST121"
              onClick={onSave}
            />
          </section>
        </section>
      </Card.Body>
    </Card>
  )
}
